import { analiticaInstance } from '@payments-checkout/shared/plugins/analitica/analitica.events';
import { Link, Text } from '@stone-payments/jade';
import { useIntl } from 'react-intl';
import { JadeProviderSecondaryColor } from '../../../providers/jadeProviderSecondaryColor';

type AddressHeaderProps = {
  country?: string;
  formName?: string;
  hideCepLink?: boolean;
  screen?: string;
};

const formatFormNameToCamelCase = (value: string) =>
  value.replace(/-([a-z])/g, (_, letter: string) => letter.toUpperCase());

export const AddressHeader = ({
  country,
  formName = 'billing-address',
  hideCepLink = false,
  screen,
}: AddressHeaderProps) => {
  const { formatMessage } = useIntl();
  const formattedFormName = formatFormNameToCamelCase(formName);

  const trackZipCodeHelpClicked = () => {
    if (!screen) return;

    analiticaInstance.events.addressEvents.zipCodeHelpClicked(screen);
  };

  return (
    <div className="flex flex-col gap-jade-100 sm:flex-row justify-between pb-jade-250">
      <Text variant="heading-small" color="high">
        {formatMessage({ id: `${formattedFormName}Form.title` })}
      </Text>
      {!hideCepLink && country === 'BR' && (
        <JadeProviderSecondaryColor>
          <Link
            href="https://buscacepinter.correios.com.br/app/endereco/index.php"
            variant="brand"
            trailing="external"
            target="_blank"
            onClick={trackZipCodeHelpClicked}
          >
            {formatMessage({ id: 'addressField.postalCode.help' })}
          </Link>
        </JadeProviderSecondaryColor>
      )}
    </div>
  );
};
